// reservebar-store.js

import {
	createProductStoreKey,
	getLiquidAddressObject,
	getLiquidClient,
	getReservebarStore,
	selectPreferredRetailer
} from './reservebar-config';
import {getAddresParams} from './reservebar-cart-modal';

export function setStore() {
	const liquids = Array.from(
		document.querySelectorAll('[reservebar-liquid-id]')
	);

	let ids = [];
	liquids.forEach((btn) => {
		const gid = btn.getAttribute('reservebar-liquid-id');
		if (!gid || gid === 'false') {
			return;
		}
		ids.push(String(gid));
	});

	let uniqueIds = ids.filter(function (item, pos) {
		return ids.indexOf(item) === pos;
	});
	if (!uniqueIds.length) {
		return;
	}

	const addrObj = getLiquidAddressObject();
	const store = getReservebarStore();

	// If we already have data for product+address in store, we don't ask for it again
	const idsToFetch = uniqueIds.filter((gid) => {
		const key = createProductStoreKey(gid, addrObj || {});
		if (!key) return true;
		const cached = store ? store.getProduct(key) : null;
		return !cached;
	});


	if (!idsToFetch.length) {
		// All necessary products are already in the cache for the current address
		return;
	}

	getLiquidClient()
		.then((liquid) => {
			const params = getAddresParams(idsToFetch);

			liquid
				.product(params)
				.then((productsMap) => {
					// Store the aggregated store for the current address (optional)
					let na = [];
					productsMap.forEach((e) => {
						na[e.id] = e;
					});

					try {
						const addrKey = createProductStoreKey(
							'__address__',
							addrObj || {}
						);
						if (addrKey && store) {
							store.setAddress(addrKey, addrObj);
						}
					} catch (e) {
						console.warn(
							'[ReserveBar] failed to set address store',
							e
						);
					}

					// For each GROUPING-ID we queried, we store the best option in store.products
					productsMap.forEach((product) => {
						const firstVariant = product.variants[0]??[];
						let price = null;
						let firstRetailer = null;

						if (
							firstVariant &&
							Array.isArray(firstVariant.retailers)
						) {
							firstRetailer =
								selectPreferredRetailer(
									firstVariant.retailers,
									firstVariant
								) || null;
							if (firstRetailer && firstRetailer.price) {
								price = firstRetailer.price;
							}
						}

						const productState = {
							hasPrice: !!price,
							price: price || null,
							productId: firstVariant
								? firstVariant.productId
								: null,
							variantId: firstRetailer
								? firstRetailer.variantId
								: null,
							retailer: firstRetailer
								? firstRetailer.retailer
								: null,
							shippingMethod: firstRetailer
								? firstRetailer.shippingMethod
								: null,
							raw: {
								product,
								variant: firstVariant,
								retailer: firstRetailer
							}
						};

						const key = createProductStoreKey(
							product.id,
							addrObj || {}
						);
						if (!key || !store) return;

						store.setProduct(key, productState);
					});
				})
				.then(() => {
					let place = getLiquidAddressObject();

					window.dispatchEvent(
						new CustomEvent('reservebar:address-updated', {
							detail: {
								address: place
							}
						})
					);
				})
				.catch((err) => {
					console.warn(
						'[ReserveBar] liquid.product error in setStore',
						err
					);
				});
		})

		.catch((err) => {
			console.warn('[ReserveBar] getLiquidClient error in setStore', err);
		});
	return true;
}
